import { FC, HTMLAttributes } from "react";
import { FormField, FormSection } from "generated/graphql";
import { TextField, Typography } from "@mui/material";
import StyledAutocomplete from "./StyledAutocomplete";

const renderField = (props: HTMLAttributes<HTMLLIElement>, field: FormField) => {
  return (
    <li {...props} key={field.id}>
      <Typography noWrap variant="subtitle2">
        {field.name}
      </Typography>
    </li>
  );
};

export interface FormFieldAutocompleteProps {
  sections?: FormSection[];
  options: FormField[];
  selected: FormField | undefined;
  onChange: (field: FormField | undefined) => void;
  disabled?: boolean;
}

const FormFieldAutoComplete: FC<FormFieldAutocompleteProps> = (props) => {
  const groupBy =
    props.sections && props.sections.length > 1
      ? (f: FormField) => props.sections?.find((s) => s.id === f.sectionId)?.name || f.name
      : undefined;
  return (
    <StyledAutocomplete<FormField, false, false, false>
      freeSolo={false}
      multiple={false}
      disabled={props.disabled}
      autoHighlight
      autoComplete
      size="small"
      style={{ fontSize: "0.8rem" }}
      fullWidth
      options={props.options}
      value={props.selected || null}
      onChange={(_evt, item) => {
        props.onChange(item || undefined);
      }}
      renderOption={renderField}
      groupBy={groupBy}
      getOptionLabel={(f: FormField) => f.name}
      renderInput={(params) => <TextField {...params} color="secondary" label="Profile Field" fullWidth />}
    />
  );
};

export default FormFieldAutoComplete;
